// client/src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getApiConfig } from '../config/markets.js';

const API_URL = getApiConfig().apiUrl;

export default function Login() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // 2) Handler del formulario
  const handleSubmit = async () => {
    setError('');

    const payload = {
      email: email.trim(),
      password: password
    };

    try {
      const res = await fetch( `${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const { message } = await res.json().catch(() => ({ message: 'Error desconocido' }));
        setError(message || t('auth.login.error.invalid'));
        return;
      }

      const data = await res.json();
      // Guardar token en localStorage para que isTokenValid() lo detecte
      localStorage.setItem('token', data.token);
      localStorage.setItem('userId', data.user.id);
      // Luego de guardarlo, redirige a dashboard
      navigate('/dashboard');
    } catch (err) {
      console.error('Error en login:', err);
      setError(t('auth.login.error.connection'));
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{t('auth.login.title')}</h2>
      <div style={styles.form}>
        <div style={styles.field}>
          <label htmlFor="email" style={styles.label}>{t('auth.login.email')}:</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />
        </div>
        <div style={styles.field}>
          <label htmlFor="password" style={styles.label}>{t('auth.login.password')}:</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
          />
        </div>
        {error && <p style={styles.error}>{error}</p>}
        <button onClick={() => handleSubmit()} style={styles.button}>{t('auth.login.button')}</button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '400px',
    margin: '4rem auto',
    padding: '2rem',
    border: '1px solid #ddd',
    borderRadius: '8px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    backgroundColor: '#fff'
  },
  title: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    fontSize: '1.5rem'
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  field: {
    marginBottom: '1rem'
  },
  label: {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: 500
  },
  input: {
    width: '100%',
    padding: '0.5rem',
    fontSize: '1rem',
    borderRadius: '4px',
    border: '1px solid #ccc'
  },
  button: {
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#423ef4',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  error: {
    color: 'red',
    marginBottom: '1rem',
    textAlign: 'center'
  }
};
